// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__199vg","placeholdersHeader":"styles_placeholdersHeader__3prQx","editorStyle":"styles_editorStyle__2B-IX","placeholdersBox":"styles_placeholdersBox__2SpGt"};